import angular from 'angular';
import companyEditFormComponent from './company-edit-form.component';

export default angular.module('components.app.admin.company.company-edit-form', [])
  .component('companyEditForm', companyEditFormComponent)
  .name;



// WEBPACK FOOTER //
// ./components/app/admin/company/company-edit-form/company-edit-form.module.js